import React, { Component } from 'react'
import DataTable from '@/components/DataTable/DataTable'
import { dataType } from '@/constants/data-type'
import { connect } from 'react-redux'
import { fundActions } from '@/actions/trading'
import Dropdown from '@/components/Dropdown/Dropdown.js'
import FundsIntl from '../../assets/files/funds.json'
import '@/assets/styles/commons/_styles.scss'
import '@/companys/ttl/assets/styles/components/market/market-funds.scss'

class MarketFunds extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ColumnDefs: [
        {
          headerName: props.language.common_instrument_id,
          colId: 'common_instrument_id',
          field: 'instrumentID',
          tooltipField:'instrumentID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
        },
        // {
        //   headerName: props.language.common_instrument_chinese_name,
        //   colId: 'common_instrument_chinese_name',
        //   field: 'chinese_name',
        //   headerClass: 'table-header',
        //   cellClass: 'table-cell',
        //   dataType: dataType.TEXT,
        // },
        {
          headerName: props.language.common_instrument_Name,
          colId: 'common_instrument_Name',
          field: 'instrumentName',
          headerClass: 'table-header',
          tooltipField: 'instrumentName',
          cellClass: 'table-cell table-ellipsis',
          dataType: dataType.TEXT,
          minWidth: 400,
        },
        // {
        //   headerName: props.language.common_provide_code,
        //   colId: 'common_provide_code',
        //   field: 'provide_code',
        //   headerClass: 'table-header',
        //   cellClass: 'table-cell',
        //   dataType: dataType.TEXT,
        // },
        {
          headerName: props.language.common_risk_objective,
          colId: 'common_risk_objective',
          field: 'risk_objective',
          tooltipField: 'risk_objective',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
        },
        {
          headerName: props.language.common_risk_level,
          colId: 'common_risk_level',
          field: 'risk_level',
          tooltipField: 'risk_level',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
        },
        {
          headerName: props.language.common_fund_house_name,
          colId: 'common_fund_house_name',
          field: 'fundHouseName',
          tooltipField: 'fundHouseName',
          headerClass: 'table-header',
          cellClass: 'table-cell table-ellipsis',
          dataType: dataType.TEXT,
          minWidth: 380
        },
        {
          headerName: props.language.common_asset_type,
          colId: 'common_asset_type',
          field: 'fundAssetType',
          tooltipField: 'fundAssetType',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          minWidth: 200
        },
        // {
        //   headerName: props.language.common_product_category,
        //   colId: 'common_product_category',
        //   field: 'fundCategory',
        //   headerClass: 'table-header',
        //   cellClass: 'table-cell',
        //   dataType: dataType.TEXT,
        // },
        {
          headerName: props.language.common_product_geo_focus,
          colId: 'common_product_geo_focus',
          field: 'fundGeoFocus',
          tooltipField: 'fundGeoFocus',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          minWidth: 200 
        },
        {
          headerName: props.language.common_product_sector,
          colId: 'common_product_sector',
          field: 'fundSector',
          tooltipField: 'fundSector',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          minWidth: 200
        },
      ].filter(Boolean),
      data: [],
      searchData: [],
      fundsSearch: [
        {
          id: 1,
          title: "common_instrument_id",
          type: "text",
          name: 'instrumentID',
          value: ""
        },
        {
          id: 2,
          title: "common_instrument_Name",
          type: "text",
          name: 'instrumentName',
          value: ""
        },
        {
          id: 3,
          title: "common_asset_type",
          type: "select",
          name: 'fundAssetType',
          value: ""
        },
        {
          id: 4,
          title: "common_product_geo_focus",
          type: "select",

          name: "fundGeoFocus",
          value: ""
        },
        // {
        //   id: 5,
        //   title: "common_provide_code",
        //   type: "select",

        //   name: "provide_code",
        //   value: ""
        // },
        {
          id: 6,
          title: "common_fund_house_name",
          type: "select",

          name: "fundHouseName",
          value: ""
        },
        // {
        //   id: 7,
        //   title: "common_product_category",
        //   type: "select",
        //   name: "fundCategory",
        //   value: ""
        // },
        {
          id: 8,
          title: "common_product_sector",
          type: "select",
          name: "fundSector",
          value: ""
        }
      ],
      fundOptions: {
        fundHouseName: [],
        fundAssetType: [],
        fundGeoFocus: [],
        fundSector: []
      },
    }
    this.selectRef = {
      fundHouseName: null,
      fundAssetType: null,
      fundGeoFocus: null,
      fundSector: null
    }
    if (props.innerRef) {
      props.innerRef(this)
    }
  }
  render() {
    const { language } = this.props
    const { ColumnDefs, data, fundsSearch, fundOptions } = this.state
    return (
      <div className='market_funds'>
      <div className='funds_box'>
        {fundsSearch.map((item,index) =>
          item.type == "text" ?
            <div className='funds_search' key={language[item.title]}>
             <span>{language[item.title]}</span>
             <div className='search_background'>           
                 <input placeholder={language[item.title]} onChange={e => this.inpFunds(e)} id={item.id} value={item.value}
                   autoComplete="off" />
             </div>
          </div> :
            <div className='funds_search funds_search_select' key={item.id}>
               <span>{language[item.title]}</span>
               <div className='search_background'>
                   <Dropdown
                    innerRef={e => this.selectRef[item.name] = e}
                    onChange={(e) => this.onChangFundsAccount(e,index)}
                    options={fundOptions[item.name]}
                    // id={item.id}
                    selectedOptions={item.value ? [item.value] : fundOptions?.[item.name]?.[0] ? [fundOptions?.[item.name]?.[0]]: []}
                    style={{ height: '100%', width: "180px" }}
                   />
               </div>
          </div>
       )}
     </div>
     <div className='funds_button'>
           <button className='btn_clear' onClick={() => this.clearInput()}>{language.common_clear} </button>
           <button className='btn_search' onClick={() => this.searchInput()}>{language.common_search}</button>
     </div>
         <DataTable
           columnDefs={ColumnDefs}
           data={data}
           innerRef={e => (this.activeRef = e)}
           showPagination={false}
         ></DataTable>
   </div>
    )
  }
  componentDidMount() {
    this.initOptons()
    this.getFunds()
  }

  onChangFundsAccount(event,index) {  
    const { fundsSearch } = this.state
    fundsSearch[index].value = event[0]
    this.setState({ fundsSearch })
  }

  initOptons() {
    const { language } = this.props
    const currentLangage = FundsIntl[language.lang]
    const fundOptions = Object.keys(currentLangage).reduce((prev, key) => {
      prev[key] = Object.keys(currentLangage[key]).reduce((options, next, index) => {
        if (!index) {
          options.push({ label: 'common_all', value: '' })
        }
        options.push({ label: `funds_options_${key}_${next}`, value: next })
        return options
      }, [])
      return prev
    }, {})
    this.setState({ fundOptions })

    
  }

  componentDidUpdate(preProps) {
    const { language } = this.props
    if (language && preProps.language !== language) {
      // this.initOptons()
      this.searchInput()
    }
  }

  componentWillUnmount() {
    this.setState = () => {}
  }

  getFunds(params = {}) {
    const { language } = this.props
    const currentLangage = FundsIntl[language.lang]

    this.activeRef.toggleLoadingOverlay(true)

    this.props.getFundMasterEnquiry({ marketID: 'FUND', ...params }, res => {

      const data = res?.result?.itemList?.map(item => {
       Object.keys(item).map(key => {
         if (currentLangage[key]) {
           item[key] = currentLangage[key][item[key]]
         }
       })
       return item
      }) || []

      this.setState({ data });
      this.activeRef.toggleLoadingOverlay(false)
    })
  }

  // fundsFilter(arr1,arr2){
  //   return arr1.filter((k)=>{
  //     arr2.filter((j)=>k.id === j.id).length >0
  //   })
  // }

  inpFunds(e) {
    const { fundsSearch } = this.state
    fundsSearch.map(item => {
      if (item.id == e.target.id) {
        item.value = e.target.value
      }
      this.setState({
        fundsSearch
      })
    })
  }

  clearInput(){
    const { language } = this.props
    const { fundsSearch } = this.state
    fundsSearch.map(item=>{
      item.value = ""
    })

    this.selectRef.fundHouseName.setValue([{ label: language.common_all, value: '' }])
    this.selectRef.fundAssetType.setValue([{ label: language.common_all, value: '' }])
    this.selectRef.fundGeoFocus.setValue([{ label: language.common_all, value: '' }])
    this.selectRef.fundSector.setValue([{ label: language.common_all, value: '' }])

    this.setState({
      fundsSearch
    })
  }

  searchInput() {
    const { fundsSearch } = this.state

    var params = {
      marketID: 'FUND',
      instrumentID: fundsSearch[0].value,
      instrumentName: fundsSearch[1].value,
      fundAssetType: typeof fundsSearch[2].value === 'object' ? fundsSearch[2].value.value : '',
      fundGeoFocus: typeof fundsSearch[3].value === 'object' ? fundsSearch[3].value.value : '',
      provide_code: "",
      fundHouseName: typeof fundsSearch[4].value === 'object' ? fundsSearch[4].value.value : '',
      fundCategory: '',
      fundSector: typeof fundsSearch[5].value === 'object' ? fundsSearch[5].value.value : '',
    }
    // fundsSearch.map(v => {
    //   if (v.value != "") {
    //     for (var key in params) {
    //       if (key == v.name) {
    //         params[v.name] = v.value
    //       }
    //     }
    //   }
    // })
    this.getFunds(params)
  }

}
export default connect(
  state => ({
    language: state.app.language,
  }),
  dispatch => ({
    getFundMasterEnquiry: (p, c) => dispatch(fundActions.getFundMasterEnquiry(p, c)),
  })
)(MarketFunds)

